import * as angular from "angular";
import {IController} from "angular";

export class BillingAccountsTableRowCtrl implements IController {
  billingAccount: any;

  constructor() {
  }
}


angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountsTableRow', {
    bindings: {
      billingAccount: '<'
    },
    template: require('./billing-accounts-table-row.html').default,
    controller: BillingAccountsTableRowCtrl
  });
